import { OpenAPI } from '../../../openapi/core/OpenAPI'
import { request as __request } from '../../../openapi/core/request'
import type { FallbackPlatform, FallbackProviderId } from './fallback-api'

/** How the client should drive the connect step for the resolved gateway. */
export type GatewayMode = 'oauth_popup' | 'redirect' | 'sdk'

/**
 * Session returned by the routed connect endpoint. Mirrors the server's
 * GatewayConnectSession: `oauth_popup` means use our own OAuth popup (direct);
 * `redirect`/`sdk` are partner gateways (Composio/Phyllo).
 */
export type GatewayConnectSession =
  // `direct_staging` = the same OAuth popup against the platform's sandbox app
  // (a Birdbrain per-business override); the server swaps the provider itself.
  | {
      mode: 'oauth_popup'
      gateway: 'direct' | 'direct_staging'
      provider: FallbackPlatform
      connectAttemptId?: string
    }
  | {
      mode: 'redirect'
      gateway: FallbackProviderId
      redirectUrl: string
      externalUserId: string
      connectAttemptId?: string
    }
  | {
      mode: 'sdk'
      gateway: FallbackProviderId
      sdkToken: string
      externalUserId: string
      environment: string
      connectAttemptId?: string
    }

/**
 * Thin wrapper around the routed connect endpoint. The server resolves which
 * gateway this (business, platform) should use for a NEW connection and
 * returns a session the client drives. Page listing + selection reuse the
 * FallbackApi.{listPages,selectPage} endpoints (shared by both flows).
 * Replace with generated calls after `yarn openapi`.
 */
export const GatewayApi = {
  connectSession(provider: FallbackPlatform): Promise<GatewayConnectSession> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/integrations/{provider}/connect-session',
      path: { provider },
    })
  },
}
